import React, { Component } from 'react'
import { Button, Container } from 'react-bootstrap'
import './Style.scss'


export class AccountOpening extends Component {
  render() {
    return (
      <>
        <section className="accountOpeningContainer">
            <Container className='accountOpening'>
                <Button className='btn accountBtn'>Open a Trading Account</Button>
            </Container>
        </section>
      </>
    )
  }
}

export default AccountOpening